import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RestService {

  private apiUrl: string;
  private authorization: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.api_url;
    this.authorization = environment.authorization;
  }

  private jwt(params?) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.authorization
    });

    return { params: params, headers: headers };
  }

  private getJSON(): Observable<any> {
    return this.http.get('./assets/config/config.json');
  }

  //TOKEN services

  setToken(token: string) {
    localStorage.setItem('token', token)
  }

  getToken() {
    return localStorage.getItem('token');
  }

  /* token_exist(data: any): Observable<any> {
      return this.http.post(this.apiUrl + "/token/exist.php", data, this.jwt());
  } */

  //user (dmp_user) services

  user_login(data: any): Observable<any> {
    return this.http.post(this.apiUrl + "/dmp_user/login.php", data, this.jwt());
  }

  login_validate(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user/login_validate.php", data, this.jwt());
  }

  user_logout() {
    localStorage.removeItem('token');
  }

  user_validate(_permission: any): Observable<any> {
    const token = this.getToken();
    if (token) {
      const data = {
        token: token,
        permission: _permission
      };
      return this.http.post(this.apiUrl + "/dmp_user/validate_permission_by_iduser.php", data, this.jwt());
    }
    return new Observable(observer => { observer.next({ success: false }) });
  }

  user_permission_by_iduser(): Observable<any> {
    const token = this.getToken();
    if (token) {
      return this.http.post(this.apiUrl + "/dmp_user/permission_by_iduser.php", { token: token }, this.jwt());
    }
    return new Observable(observer => { observer.next({ success: false }) });
  }

  user_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user/create.php", data, this.jwt());
  }

  user_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user/delete.php", data, this.jwt());
  }

  user_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user/read.php", data, this.jwt());
  }

  user_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    if (data.token) {
      return this.http.post(this.apiUrl + "/dmp_user/read_one.php", data, this.jwt());
    }
    return new Observable(observer => { observer.next({ success: false }) });
  }

  user_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user/update.php", data, this.jwt());
  }

  //process (process) services

  process_continue(data: any): Observable<any> {
    return this.http.post(this.apiUrl + "/process/continue.php", data, this.jwt());
  }

  process_continue_data(data: any): Observable<any> {
    return this.http.post(this.apiUrl + "/process/continue_data.php", data, this.jwt());
  }

  //rol (dmp_rol) services

  rol_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/create.php", data, this.jwt());
  }

  rol_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/delete.php", data, this.jwt());
  }

  rol_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/read.php", data, this.jwt());
  }

  rol_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/read_one.php", data, this.jwt());
  }

  rol_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/update.php", data, this.jwt());
  }

  rol_read_config(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/read_config.php", data, this.jwt());
  }

  rol_set_config(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_rol/set_config.php", data, this.jwt());
  }

  //section_site (dmp_section_site) services

  section_site_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/create.php", data, this.jwt());
  }

  section_site_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/delete.php", data, this.jwt());
  }

  section_site_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/read.php", data, this.jwt());
  }

  section_site_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/read_one.php", data, this.jwt());
  }

  section_site_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/update.php", data, this.jwt());
  }

  section_site_read_filter_section(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/read_filter_section.php", data, this.jwt());
  }

  section_site_read_with_count(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/read_with_count.php", data, this.jwt());
  }

  section_site_sync_dfp(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_section_site/sync_dfp.php", data, this.jwt());
  }

  //topic_site (dmp_topic_site) services

  topic_site_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/create.php", data, this.jwt());
  }

  topic_site_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/delete.php", data, this.jwt());
  }

  topic_site_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/read.php", data, this.jwt());
  }

  topic_site_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/read_one.php", data, this.jwt());
  }

  topic_site_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/update.php", data, this.jwt());
  }

  topic_site_read_with_count(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/read_with_count.php", data, this.jwt());
  }

  topic_site_sync_dfp(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_topic_site/sync_dfp.php", data, this.jwt());
  }

  //ad_platform (dmp_ad_platform) services

  ad_platform_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_platform/create.php", data, this.jwt());
  }

  ad_platform_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_platform/delete.php", data, this.jwt());
  }

  ad_platform_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_platform/read.php", data, this.jwt());
  }

  ad_platform_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_platform/read_one.php", data, this.jwt());
  }

  ad_platform_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_platform/update.php", data, this.jwt());
  }

  //ad_position (dmp_ad_position) services

  ad_position_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_position/create.php", data, this.jwt());
  }

  ad_position_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_position/delete.php", data, this.jwt());
  }

  ad_position_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_position/read.php", data, this.jwt());
  }

  ad_position_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_position/read_one.php", data, this.jwt());
  }

  ad_position_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_position/update.php", data, this.jwt());
  }

  //ad_unit (dmp_ad_unit) services

  ad_unit_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit/create.php", data, this.jwt());
  }

  ad_unit_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit/delete.php", data, this.jwt());
  }

  ad_unit_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit/read.php", data, this.jwt());
  }

  ad_unit_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit/read_one.php", data, this.jwt());
  }

  ad_unit_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit/update.php", data, this.jwt());
  }

  //ad_unit_has_section_site (dmp_ad_unit_has_section_site) services

  ad_unit_has_section_site_read_by_idsection_site(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_section_site/read_by_idsection_site.php", data, this.jwt());
  }

  ad_unit_has_section_site_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_section_site/create.php", data, this.jwt());
  }

  ad_unit_has_section_site_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_section_site/delete.php", data, this.jwt());
  }

  //ad_unit_has_topic_site (dmp_ad_unit_has_topic_site) services

  ad_unit_has_topic_site_read_by_idtopic_site(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_topic_site/read_by_idtopic_site.php", data, this.jwt());
  }

  ad_unit_has_topic_site_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_topic_site/create.php", data, this.jwt());
  }

  ad_unit_has_topic_site_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_ad_unit_has_topic_site/delete.php", data, this.jwt());
  }


  //country (dmp_country) services

  country_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country/create.php", data, this.jwt());
  }

  country_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country/delete.php", data, this.jwt());
  }

  country_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country/read.php", data, this.jwt());
  }

  country_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country/read_one.php", data, this.jwt());
  }

  country_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country/update.php", data, this.jwt());
  }

  //country_state (dmp_country_state) services

  country_state_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/create.php", data, this.jwt());
  }

  country_state_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/delete.php", data, this.jwt());
  }

  country_state_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/read.php", data, this.jwt());
  }

  country_state_read_use_user_site(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/read_use_user_site.php", data, this.jwt());
  }

  country_state_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/read_one.php", data, this.jwt());
  }

  country_state_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_country_state/update.php", data, this.jwt());
  }

  //user_site (dmp_user_site) services

  user_site_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site/read.php", data, this.jwt());
  }

  user_site_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site/read_one.php", data, this.jwt());
  }

  user_site_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site/update.php", data, this.jwt());
  }

  user_site_read_by_idfield(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site/read_by_idfield.php", data, this.jwt());
  }

  //segment (dmp_segment) services

  segment_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/create.php", data, this.jwt());
  }

  segment_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/delete.php", data, this.jwt());
  }

  segment_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/read.php", data, this.jwt());
  }

  segment_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/read_one.php", data, this.jwt());
  }

  segment_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/update.php", data, this.jwt());
  }

  segment_read_history(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/read_history.php", data, this.jwt());
  }

  segment_read_users(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/read_users.php", data, this.jwt());
  }

  data_segment_group(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/data_segment_group.php", data, this.jwt());
  }

  process_segment(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/process_segment.php", data, this.jwt());
  }

  segment_sync_dfp(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/sync_dfp.php", data, this.jwt());
  }

  segment_read_by_idfield(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment/read_by_idfield.php", data, this.jwt());
  }

  //field (dmp_field) services

  field_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/create.php", data, this.jwt());
  }

  field_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/delete.php", data, this.jwt());
  }

  field_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/read.php", data, this.jwt());
  }

  field_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/read_one.php", data, this.jwt());
  }

  field_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/update.php", data, this.jwt());
  }

  field_read_basic(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/read_basic.php", data, this.jwt());
  }

  field_read_use(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field/read_use.php", data, this.jwt());
  }

  //field_detail (dmp_field_detail) services

  field_detail_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field_detail/create.php", data, this.jwt());
  }

  field_detail_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field_detail/delete.php", data, this.jwt());
  }

  field_detail_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field_detail/read.php", data, this.jwt());
  }

  field_detail_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field_detail/read_one.php", data, this.jwt());
  }

  field_detail_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_field_detail/update.php", data, this.jwt());
  }

  //event_site (dmp_event_site) services

  event_site_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site/create.php", data, this.jwt());
  }

  event_site_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site/delete.php", data, this.jwt());
  }

  event_site_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site/read.php", data, this.jwt());
  }

  event_site_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site/read_one.php", data, this.jwt());
  }

  event_site_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site/update.php", data, this.jwt());
  }

  //event_site_detail (dmp_event_site_detail) services

  event_site_detail_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site_detail/create.php", data, this.jwt());
  }

  event_site_detail_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site_detail/delete.php", data, this.jwt());
  }

  event_site_detail_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site_detail/read.php", data, this.jwt());
  }

  event_site_detail_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site_detail/read_one.php", data, this.jwt());
  }

  event_site_detail_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_event_site_detail/update.php", data, this.jwt());
  }

  //segment_element_and (dmp_segment_element_and) services

  segment_element_and_create_by_idsegment(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment_element_and/create_by_idsegment.php", data, this.jwt());
  }

  segment_element_and_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment_element_and/read.php", data, this.jwt());
  }

  //param (dmp_param) services

  param_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param/create.php", data, this.jwt());
  }

  param_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param/delete.php", data, this.jwt());
  }

  param_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param/read.php", data, this.jwt());
  }

  param_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param/read_one.php", data, this.jwt());
  }

  param_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param/update.php", data, this.jwt());
  }

  //register_control (dmp_register_control) services

  register_control_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_register_control/create.php", data, this.jwt());
  }

  register_control_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_register_control/delete.php", data, this.jwt());
  }

  register_control_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_register_control/read.php", data, this.jwt());
  }

  register_control_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_register_control/read_one.php", data, this.jwt());
  }

  register_control_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_register_control/update.php", data, this.jwt());
  }

  //register_control (dmp_user_site_has_field) services

  user_site_has_field_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/create.php", data, this.jwt());
  }

  user_site_has_field_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/delete.php", data, this.jwt());
  }

  user_site_has_field_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/read.php", data, this.jwt());
  }

  user_site_has_field_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/read_one.php", data, this.jwt());
  }

  user_site_has_field_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/update.php", data, this.jwt());
  }

  user_site_has_field_read_by_iduser_site(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_has_field/read_by_iduser_site.php", data, this.jwt());
  }

  //segment_has_user_site (dmp_segment_has_user_site) services

  segment_has_user_site_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_segment_has_user_site/read.php", data, this.jwt());
  }

  //dashboard_registered_user (dashboard_registered_user) services
  dashboard_user_get_data_registered(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_user/get_data_registered.php", data, this.jwt());
  }

  dashboard_user_get_data_anonymus(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_user/get_data_anonymus.php", data, this.jwt());
  }

  dashboard_user_get_created_segment(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_user/get_created_segment.php", data, this.jwt());
  }

  dashboard_user_get_source_and_campaign(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_user/get_source_and_campaign.php", data, this.jwt());
  }

  //dashboard_home (dashboard_home) services
  dashboard_home_get_data(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data.php", data, this.jwt());
  }

  dashboard_home_get_count_view_page(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_count_view_page.php", data, this.jwt());
  }

  dashboard_home_get_data_top_views_topic(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data_top_views_topic.php", data, this.jwt());
  }

  dashboard_home_get_data_top_views_topic_article(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data_top_views_topic_article.php", data, this.jwt());
  }

  dashboard_home_get_data_top_views_section(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data_top_views_section.php", data, this.jwt());
  }

  dashboard_home_get_data_top_views_article(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data_top_views_article.php", data, this.jwt());
  }

  dashboard_home_get_data_top_realized_event(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_home/get_data_top_realized_event.php", data, this.jwt());
  }


  //keyword (dmp_keyword) services

  keyword_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/create.php", data, this.jwt());
  }

  keyword_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/delete.php", data, this.jwt());
  }

  keyword_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/read.php", data, this.jwt());
  }

  keyword_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/read_one.php", data, this.jwt());
  }

  keyword_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/update.php", data, this.jwt());
  }

  keyword_sync_dfp(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_keyword/sync_dfp.php", data, this.jwt());
  }

  //promotion (dmp_promotion) services

  promotion_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/create.php", data, this.jwt());
  }

  promotion_campaign_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_campaign/create.php", data, this.jwt());
  }

  promotion_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/delete.php", data, this.jwt());
  }

  promotion_campaign_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_campaign/delete.php", data, this.jwt());
  }

  promotion_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/read.php", data, this.jwt());
  }

  promotion_campaign_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_campaign/read.php", data, this.jwt());
  }

  promotion_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/read_one.php", data, this.jwt());
  }

  promotion_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/update.php", data, this.jwt());
  }

  promotion_campaign_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_campaign/update.php", data, this.jwt());
  }

  promotion_report(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/report.php", data, this.jwt());
  }

  promotion_participant_list(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/participant_list.php", data, this.jwt());
  }

  promotion_save_draw(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/save_draw.php", data, this.jwt());
  }

  promotion_update_state_realized(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/update_state_realized.php", data, this.jwt());
  }

  promotion_read_by_idfield(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion/read_by_idfield.php", data, this.jwt());
  }

  promotion_exception_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_exception/create.php", data, this.jwt());
  }

  promotion_exception_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_exception/delete.php", data, this.jwt());
  }

  promotion_exception_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_exception/read.php", data, this.jwt());
  }

  promotion_exception_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_exception/read_one.php", data, this.jwt());
  }

  promotion_exception_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_promotion_exception/update.php", data, this.jwt());
  }

  //currency (dmp_currency) services

  currency_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_currency/create.php", data, this.jwt());
  }

  currency_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_currency/delete.php", data, this.jwt());
  }

  currency_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_currency/read.php", data, this.jwt());
  }

  currency_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_currency/read_one.php", data, this.jwt());
  }

  currency_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_currency/update.php", data, this.jwt());
  }

  //campaign_category (dmp_campaign_category) services

  campaign_category_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_campaign_category/create.php", data, this.jwt());
  }

  campaign_category_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_campaign_category/delete.php", data, this.jwt());
  }

  campaign_category_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_campaign_category/read.php", data, this.jwt());
  }

  campaign_category_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_campaign_category/read_one.php", data, this.jwt());
  }

  campaign_category_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_campaign_category/update.php", data, this.jwt());
  }

  //format (dmp_format) services

  format_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_format/create.php", data, this.jwt());
  }

  format_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_format/delete.php", data, this.jwt());
  }

  format_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_format/read.php", data, this.jwt());
  }

  format_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_format/read_one.php", data, this.jwt());
  }

  format_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_format/update.php", data, this.jwt());
  }

  //art (dmp_art) services

  art_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/create.php", data, this.jwt());
  }

  art_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/delete.php", data, this.jwt());
  }

  art_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/read.php", data, this.jwt());
  }

  art_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/read_one.php", data, this.jwt());
  }

  art_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/update.php", data, this.jwt());
  }

  art_read_preview(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/read_preview.php", data, this.jwt());
  }

  art_read_code(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/read_code.php", data, this.jwt());
  }
  art_update_code(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art/update_code.php", data, this.jwt());
  }

  //art_variable (dmp_art_variable) services

  art_variable_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_variable/create.php", data, this.jwt());
  }

  art_variable_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_variable/delete.php", data, this.jwt());
  }

  art_variable_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_variable/read.php", data, this.jwt());
  }

  art_variable_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_variable/read_one.php", data, this.jwt());
  }

  art_variable_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_variable/update.php", data, this.jwt());
  }

  //art_price (dmp_art_price) services

  price_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_price/create.php", data, this.jwt());
  }

  price_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_price/delete.php", data, this.jwt());
  }

  price_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_price/read.php", data, this.jwt());
  }

  price_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_price/read_one.php", data, this.jwt());
  }

  price_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_price/update.php", data, this.jwt());
  }

  //dashboard_admanager (dashboard) service
  adm_dashboard_admanager(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_admanager/get_data.php", data, this.jwt());
  }

  //dashboard_promotion (dashboard) service
  adm_dashboard_promotion(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_promotion/get_data.php", data, this.jwt());
  }

  //dashboard_promotion (dashboard) service
  adm_dashboard_segment(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_segment/get_data.php", data, this.jwt());
  }

  //dashboard_adblock (dashboard) service
  adm_dashboard_adblock(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_adblock/get_data.php", data, this.jwt());
  }

  //dashboard_adblock (dashboard) service
  adm_dashboard_website(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_website/get_data.php", data, this.jwt());
  }

  //Info_anonymous_User_sesion (dmp_user_site_session) service
  read_without_iduser_site(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_session/read_without_iduser_site.php", data, this.jwt());
  }

  read_last_by_idbrowser(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_session/read_last_by_idbrowser.php", data, this.jwt());
  }

  read_navigation_by_idbrowser(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_session/read_navigation_by_idbrowser.php", data, this.jwt());
  }

  read_navigation_by_iduser_site(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_session/read_navigation_by_iduser_site.php", data, this.jwt());
  }

  read_one_session(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_session/read_one.php", data, this.jwt());
  }

  //Info_anonymous_User_pageview (dmp_user_site_pageview) service
  read_one_pageview(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_pageview/read_one.php", data, this.jwt());
  }

  //Info_anonymous_User_event (dmp_user_site_event) service
  read_one_event(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_user_site_event/read_one.php", data, this.jwt());
  }

  //Art_element (dmp_art_element) service
  art_element_create(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element/create.php", data, this.jwt());
  }

  art_element_read(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element/read.php", data, this.jwt());
  }

  art_element_read_one(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element/read_one.php", data, this.jwt());
  }

  art_element_update(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element/update.php", data, this.jwt());
  }

  art_element_delete(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element/delete.php", data, this.jwt());
  }

  //Art_element_category (dmp_art_element_category) service
  art_element_category_create(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/create.php", data, this.jwt());
  }

  art_element_category_read(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/read.php", data, this.jwt());
  }

  art_element_category_read_group(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/read_group.php", data, this.jwt());
  }

  art_element_category_read_one(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/read_one.php", data, this.jwt());
  }

  art_element_category_update(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/update.php", data, this.jwt());
  }

  art_element_category_delete(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_art_element_category/delete.php", data, this.jwt());
  }

  //Multimedia_item_category (dmp_multimedia_item_category) service
  multimedia_item_category_create(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item_category/create.php", data, this.jwt());
  }

  multimedia_item_category_read(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item_category/read.php", data, this.jwt());
  }

  multimedia_item_category_read_one(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item_category/read_one.php", data, this.jwt());
  }

  multimedia_item_category_update(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item_category/update.php", data, this.jwt());
  }

  multimedia_item_category_delete(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item_category/delete.php", data, this.jwt());
  }

  //Multimedia_item (dmp_multimedia_item) service
  multimedia_item_create(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/create.php", data, this.jwt());
  }

  multimedia_item_read(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/read.php", data, this.jwt());
  }

  multimedia_item_read_one(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/read_one.php", data, this.jwt());
  }

  multimedia_item_update(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/update.php", data, this.jwt());
  }

  multimedia_item_delete(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/delete.php", data, this.jwt());
  }

  multimedia_item_read_displayable(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_multimedia_item/read_displayable.php", data, this.jwt());
  }

  //Params Tariffv2 (dmp_param_tariffv2) service
  param_tariffv2_read(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param_tariffv2/read.php", data, this.jwt());
  }

  param_tariffv2_update(data): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_param_tariffv2/update.php", data, this.jwt());
  }

  //mail_sender (dmp_mail_sender) services
  mail_sender_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_sender/create.php", data, this.jwt());
  }

  mail_sender_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_sender/delete.php", data, this.jwt());
  }

  mail_sender_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_sender/read.php", data, this.jwt());
  }

  mail_sender_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_sender/read_one.php", data, this.jwt());
  }

  mail_sender_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_sender/update.php", data, this.jwt());
  }

  //mail_list(dmp_mail_list) services
  mail_list_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/create.php", data, this.jwt());
  }

  mail_list_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/read.php", data, this.jwt());
  }

  mail_list_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/update.php", data, this.jwt());
  }

  mail_list_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/delete.php", data, this.jwt());
  }


  mail_list_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/read_one.php", data, this.jwt());
  }

  mail_list_recipient_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/recipient_create.php", data, this.jwt());
  }

  mail_list_read_recipient(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/read_recipient.php", data, this.jwt());
  }

  mail_list_recipient_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/recipient_delete.php", data, this.jwt());
  }

  mail_list_read_history(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_list/read_history.php", data, this.jwt());
  }

  //mail_content_source(dmp_mail_content_source) services
  mail_content_source_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/create.php", data, this.jwt());
  }

  mail_content_source_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/read.php", data, this.jwt());
  }

  mail_content_source_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/update.php", data, this.jwt());
  }

  mail_content_source_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/delete.php", data, this.jwt());
  }

  mail_content_source_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/read_one.php", data, this.jwt());
  }

  mail_content_source_create_items(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/create_items.php", data, this.jwt());
  }

  mail_content_source_read_items(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_content_source/read_items.php", data, this.jwt());
  }

  //mail_banner (dmp_mail_banner) services
  mail_banner_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_banner/create.php", data, this.jwt());
  }

  mail_banner_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_banner/read.php", data, this.jwt());
  }

  mail_banner_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_banner/update.php", data, this.jwt());
  }

  mail_banner_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_banner/delete.php", data, this.jwt());
  }

  mail_banner_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_banner/read_one.php", data, this.jwt());
  }

  //mail_campaign_group (dmp_mail_campaign_group) services
  mail_campaign_group_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group/create.php", data, this.jwt());
  }

  mail_campaign_group_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group/read.php", data, this.jwt());
  }

  mail_campaign_group_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group/update.php", data, this.jwt());
  }

  mail_campaign_group_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group/delete.php", data, this.jwt());
  }

  mail_campaign_group_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group/read_one.php", data, this.jwt());
  }

  //mail_campaign_group_list (dmp_mail_campaign_group_list) services
  mail_campaign_group_list_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group_list/create.php", data, this.jwt());
  }

  mail_campaign_group_list_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group_list/read.php", data, this.jwt());
  }

  mail_campaign_group_list_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_group_list/delete.php", data, this.jwt());
  }

  //mail_campaign (dmp_mail_campaign) services
  mail_campaign_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/create.php", data, this.jwt());
  }

  mail_campaign_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/delete.php", data, this.jwt());
  }

  mail_campaign_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/read.php", data, this.jwt());
  }

  mail_campaign_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/read_one.php", data, this.jwt());
  }

  mail_campaign_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/update.php", data, this.jwt());
  }

  mail_campaign_read_report(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/read_report.php", data, this.jwt());
  }

  mail_campaign_update_state(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/update_state.php", data, this.jwt());
  }

  mail_campaign_read_html(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign/read_html.php", data, this.jwt());
  }

  //mail_campaign_body (dmp_mail_campaign_body) services
  mail_campaign_body_create(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_body/create.php", data, this.jwt());
  }

  mail_campaign_body_delete(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_body/delete.php", data, this.jwt());
  }

  mail_campaign_body_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_body/read.php", data, this.jwt());
  }

  mail_campaign_body_read_one(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_body/read_one.php", data, this.jwt());
  }

  mail_campaign_body_update(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dmp_mail_campaign_body/update.php", data, this.jwt());
  }

  //dashboard_emarketing (dashboard_emarketing) services
  dashboard_emarketing_read(data: any): Observable<any> {
    data.token = this.getToken();
    return this.http.post(this.apiUrl + "/dashboard_emarketing/get_data.php", data, this.jwt());
  }


  //Other rest functions
  getImage(imageUrl, imgName) {
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = imgName;  // Nombre del archivo descargado
      link.click();
      window.URL.revokeObjectURL(url); // Limpiar el objeto URL
    }, error => {
      console.error("Error al descargar la imagen: ", error);
    });
  }

  fetchSchema(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'text' });
  }

}